import { trackError, trackEvent } from '@vp/om-newrelic-tracker';
import { NR_AGENT_ID } from '../constants/newRelic';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackNREvent = (actionName: string, eventData: any = {}) => {
  const debug = process.env.NODE_ENV !== 'production';
  trackEvent(NR_AGENT_ID, actionName, eventData, debug);
};

export const trackNRError = (
  error: Error,
  inputErrorData?: object,
  errorName?: string
) => {
  const debug = process.env.NODE_ENV !== 'production';
  const errorData = {
    ...(inputErrorData || {}),
    errorName,
    qmReplay: getQmReplayLink(),
  };

  trackError(NR_AGENT_ID, error, errorData, debug);
};

/* global QuantumMetricAPI */
declare global {
  const QuantumMetricAPI: any;
}

const getQmReplayLink = () => {
  try {
    if (
      typeof QuantumMetricAPI !== 'undefined' &&
      !!QuantumMetricAPI.getReplay
    ) {
      return QuantumMetricAPI.getReplay();
    }
  } catch {
    // Don't let QM rain on our parade
  }
};
